import React from 'react';
import { AppUrlField } from '../Components/ui/field';
import { AppText } from '../Components/ui/text';

/**
 * Renders the publications for a given item (used in Booking, InfoRequest, etc.)
 * @param record An object with an 'item' property containing publications and thirdLevel
 * @param permissions The user object, used to check for admin privileges
 * @returns JSX.Element
 */
export default function renderItemPublications(record: any, permissions?: any): React.ReactNode {
  const item = record?.item || record?.ITEM_BASE_SOURCE || record;
  if (!item) return <AppText children="-" />;
  if (!item.publications || !Array.isArray(item.publications)) {
    return <AppText children="-" />;
  }
  const published = item.publications.filter((p: any) => p.isPublished);
  if (published.length === 0) {
    return <AppText children="Nessuna pubblicazione attiva su questo lotto" />;
  }
  return published.flatMap((p: any, idx: number) => {
    let results: React.ReactNode[] = [];
    if (p.property.name === 'Casa delle Aste' && item?.thirdLevel) {
      const propertyHostArr = p.property?.host.split('://');
      const thirdLevelUrl = `${propertyHostArr?.[0]}://${item.thirdLevel}.${propertyHostArr?.[1]}/annunci/${p.slug}`;
      results.push(
        <AppUrlField
          key={`thirdLevel-${p.slug || idx}`}
          url={thirdLevelUrl}
          text={`${item.thirdLevel.toUpperCase()}`}
          component="p"
        />,
      );
      // Also show the standard Casa delle Aste URL
      const standardUrl = `${p.property?.host}/annunci/${p.slug}`;
      results.push(
        <AppUrlField
          key={`standard-${p.slug || idx}`}
          url={standardUrl}
          text={`${p.property.name}`}
          component="p"
        />,
      );
    } else {
      const url = `${p.property?.host}/annunci/${p.slug}`;
      results.push(
        <AppUrlField key={p.slug || idx} url={url} text={p.property.name} component="p" />,
      );
    }
    return results;
  });
}
